import { render, staticRenderFns } from "./48.vue?vue&type=template&id=7f845f4b&scoped=true&"
import script from "./48.vue?vue&type=script&lang=js&"
export * from "./48.vue?vue&type=script&lang=js&"
import style0 from "./48.vue?vue&type=style&index=0&id=7f845f4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f845f4b",
  null
  
)

export default component.exports